import React, { useContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import { AudioPlayerWrap } from "./AudioArticleStyle";
import { PageContainer } from "../../component/Xcomponent";
import { Col, Row } from "antd";
import HeaderContext from "../../context/HeaderContext";

const AudioArticle = (props) => {
  const {setTitle} = useContext(HeaderContext);
  setTitle("Audio");

  return (
    <Row gutter={[24, 24]}>
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <AudioPlayerWrap>
          <AudioPlayer
            style={{ marginLeft: "6px", marginTop: "6px" }}
            autoPlay={false}
            src={
              "https://lilac-dtrf-attactments.s3.ap-south-1.amazonaws.com/article/" +
              props.ArticleData.audio_path
            }
          />
          {/* src={"https://naasongs.vip/myuploads/uploads/English%20Songs/I'm%20an%20Albatraoz.mp3"}/> */}
        </AudioPlayerWrap>
      </Col>
    </Row>
  );
};
export default AudioArticle;
